import { render } from "./BrandWordmark.vue?vue&type=template&id=c9af70e4&scoped=true"
const script = {}

import "./BrandWordmark.vue?vue&type=style&index=0&id=c9af70e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9af70e4"]])

export default __exports__